module.exports = __webpack_public_path__ + "static/media/Two-Icon.6e48b459.svg";